var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _polygon, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _polygon2, _path17, _polygon3, _polygon4, _polygon5, _path18, _path19;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMetamask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    baseProfile: "basic",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e27625",
    d: "M6.063,5L21.59,16.796L19.063,10L6.063,5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e27625",
    d: "M4,32l3,9l9.062-3l-4.333-6.065L4,32z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#e27625",
    d: "M15.313,20.375L12.938,25l9.125,0.25L21.188,15L15.313,20.375z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#e27625",
    d: "M16.063,38l5.031-2l-4.531-4L16.063,38z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7ccc8",
    d: "M16.063,38l4.812,2.875L21.094,36L16.063,38z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#cc6228",
    d: "M16.062,38l0.5-6h-4.875L16.062,38z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fb8c00",
    d: "M21.688,25l-0.777,4.854l1.036,5.334l0.232-7.03L21.688,25z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#763e1a",
    d: "M4.063,11l3,13l8.33-2.795L21.063,16l-15-11L4.063,11z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fb8c00",
    points: "21.063,29.25 13.063,25 15.392,21.205 7.062,24 4,32 16.563,32 21.094,36 21.946,35.188"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#cc6228",
    d: "M16.563,28.5l4.5,1.5l0.625-5h-8.625L16.563,28.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M21.063,30l-4.5-1.5l3.125-1.5L21.063,30z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#e27625",
    d: "M29.029,10l-2.528,6.796L42.029,5L29.029,10z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#e27625",
    d: "M36.363,31.935L32.063,38l9.029,3l3-9L36.363,31.935z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#e27625",
    d: "M26.813,15.25l-0.45,10.087L35.154,25l-2.092-4L26.813,15.25z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#e27625",
    d: "M31.529,32l-4.498,4l5.031,2L31.529,32z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7ccc8",
    d: "M27.031,36l0.186,4.875L32.063,38L27.031,36z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#cc6228",
    d: "M36.404,32h-4.875l0.533,6L36.404,32z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#bcaaa4",
    points: "27.404,40.447 27.404,39 20.688,39 20.688,40.447 16.063,38 21.063,42 27.029,42 32.063,38"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#763e1a",
    d: "M42.029,5L27.063,16l5.637,5.205L41.062,24l2.967-13L42.029,5z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fb8c00",
    points: "41.063,24 32.7,21.205 35.029,25 27.137,29.576 26.404,25 25.914,28.158 26.146,35.188 26.147,35.181 26.146,35.188 27.031,36 31.529,32 44.092,32"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fb8c00",
    points: "19.063,10 21.063,16 21.729,25.337 21.93,28.173 21.946,35.188 24.045,35.188 24.045,35.143 24.047,35.188 26.146,35.188 26.162,28.173 26.363,25.337 27.063,16 29.063,10"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#212121",
    points: "27.063,36 26.123,35 21.969,35 21.063,36 20.688,39 27.404,39"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#cc6228",
    d: "M35.029,25h-8.625l0.625,5l4.5-1.5L35.029,25z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M28.438,27l3.092,1.5l-4.5,1.5L28.438,27z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.d432eb7ad5591e2d67cfca7015d9f645.svg";
export { ForwardRef as ReactComponent };